require('./mortgageRequestPreApprovalView.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ actions
const mortgageRequestActions = require('actions/mortgageRequest/mortgageRequestPreApproval');
const mortgageRequestTaxesInformationActions = require('actions/mortgageRequest/mortgageRequestTaxesInformation');
const linkClientActions = require('actions/mortgageRequest/mortgageRequestSimulationLinkClient');
const collectivesActions = require('actions/collectives');
const mortgageRequestConditionsActions = require('actions/mortgageRequest/mortgageRequestConditions');
//@core
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
//@components
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const MortgageRequestPreApproval = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestPreApproval');
// @ utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
//@constants
const { EURO_TEXT, WIZARD_FIRST_STEP, WIZARD_SECOND_STEP, WIZARD_THIRD_STEP, WIZARD_FOURTH_STEP } = require('constants/index');
const mortgageRequestStates = require('constants/mortgageRequestStates');
const INVALID_MORTGAGES_STATES = [
    mortgageRequestStates.SIMULACION,
    mortgageRequestStates.PRE_APROBACION,
    mortgageRequestStates.PRE_APROBADO,
    mortgageRequestStates.TASA_ESF_KO,
    mortgageRequestStates.ANULADO,
    mortgageRequestStates.FIRMADO,
    mortgageRequestStates.UNKNOWN,
    mortgageRequestStates.SIN_EXPEDIENTE
];
const { MORTGAGE_TYPE } = require('constants/mortgageRequestType')
const { names, codes } = require('constants/communityCodes');
const { MORTGAGE_COLLECTIVE_PRODUCT_ALIAS, GENERIC_UI_COMPONENT_ID } = require('constants/mortgageRequestPreApproval').mortgageRequestPreApprovalCommons;
// @commons
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');


class MortgageRequestPreApprovalView extends React.Component {
    static productTypes = {
        FIJO: 'Fija',
        MIXTO: 'Mixta',
        VARIABLE: 'Variable'
    };

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
        const { immMortgageRequestState, immMortgageRequest, history, location, setInfoFromPublicUrl } = this.props;
        const visibleStep =immMortgageRequest.get('visibleStep')
        const queryParams = new URLSearchParams(location.search);
        if(visibleStep === WIZARD_FIRST_STEP && queryParams.size > 0) {
            setInfoFromPublicUrl(queryParams)
        }

        const currentState = immMortgageRequestState.get('estado');
        if (!!currentState && INVALID_MORTGAGES_STATES.indexOf(currentState) === -1) {
            history.push('/myprofile/mortgage/panel');
        }
    }

    componentDidMount() {
        const { getCollectiveInfo } = this.props;
        // Position in the top of page after load
        scrollToTop();
        getCollectiveInfo([{ alias: MORTGAGE_COLLECTIVE_PRODUCT_ALIAS }], GENERIC_UI_COMPONENT_ID);
    }

    buildDisclaimer() {
        const {
            immMortgageRequest
        } = this.props;

        const visibleStep = immMortgageRequest.get('visibleStep');

        if (visibleStep === WIZARD_FIRST_STEP) {

            return (
                <div className="mortgage-request-pre-approval__disclaimer">
                    <p><FormattedText value="calculateQuota-footerText" /></p>
                </div>
            );
        }
    }

    buildFooter() {
        const {immMortgageRequest} = this.props;
        const productType =immMortgageRequest.get('productType')
        const visibleStep =immMortgageRequest.get('visibleStep')

        if((productType !== MORTGAGE_TYPE.FIJO || visibleStep === WIZARD_SECOND_STEP) &&  visibleStep !== WIZARD_FIRST_STEP ) {
            return(
                <p className='mortgage-request-pre-approval__disclaimer'>
                {formatText('mortgageRequestMortgageEdit-mortgageModifyLegalText')}
                </p>
            )
        }

    }

    buildPreApprovalFooter() {
        const {immMortgageRequest} = this.props;
        const visibleStep =immMortgageRequest.get('visibleStep')
const showCounterOfferView = immMortgageRequest.get('showCounterOfferView');
        if( (visibleStep === WIZARD_THIRD_STEP || visibleStep === WIZARD_FOURTH_STEP) && !showCounterOfferView) {
            return(
                <p className='mortgage-request-pre-approval__disclaimer'>
                {formatText('mortgageRequestMortgageEdit-mortgagePreApprovalText')}
                </p>
            )
        }

    }

    buildBreadcrum() {
        return [
            {
                text: formatText('breadcrumb-loansAndMortgages'),
                url: `/myprofile/loans-mortgages`
            },
            {
                text: formatText('mortgageRequestPresentation-title')
            }
        ];
    }

    buildContent() {
        const {
            immMortgageRequest,
            immProfile,
            immGlobalVariables,
            immMortgageRequestState,
            immGlobalPosition,
            setVisibleStep,
            validateStep,
            setHolder,
            setDayOfBirth,
            setMonthOfBirth,
            setYearOfBirth,
            setInfoStepOne,
            setMoneyNeedPercentageValue,
            setOwner,
            setWork,
            setStudies,
            setMaritalStatus,
            setDependents,
            setInfoOtherLoansMortgages,
            setIncomes,
            setExpenses,
            handleKoReturnWizard,
            validateObligatoryFields,
            loadValidateObligatoryFields,
            dirtyWhereHousingField,
            setValidFirstStep,
            changeModalActive,
            linkMortgage,
            preApprovalLoadAFI,
            preApprovalLoadAFIFinish,
            preApprovalUUID,
            getInsurancesDataAfi,
            mortgageHomeInsurance,
            productTypeInf,
            toggleCounterOfferView,
            acceptPreApprovalCounterOffer,
            resetState,
            preApprovalRequest,
            taxesInformationRequest,
            immTaxesInformation,
            actionPreviousNextButton,
            getCatalogInformation,
            savePartialProcess,
            restoreProcess,
            immMortgageRequestSimulationLinkClient,
            savePersonalData,
            discardTemporalChangesInCurrentModal,
            flagBasedFeatures,
            clearTemporalChangesInCurrentModal,
            immCollectives,
            setMaxHousingCost,
            setNeedMoneyByUser,
            requestConditions,
            mortgageConditions,
            history,
            immScreen
        } = this.props;

        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");

        const formHandlers = {
            handleHolderRadioChange: (holder) => setHolder(holder, history),
            handleHolderDayOfBirthChange: setDayOfBirth,
            handleHolderMonthOfBirthChange: setMonthOfBirth,
            handleHolderYearOfBirthChange: setYearOfBirth,
            handleInfoStepOne: setInfoStepOne,
            setMoneyNeedPercentage: setMoneyNeedPercentageValue,
            handleOwner: setOwner,
            handleWork: setWork,
            handleStudies: setStudies,
            handleMaritalStatus: setMaritalStatus,
            handleDependents: setDependents,
            handlerInfoOtherLoansMortgages: setInfoOtherLoansMortgages,
            handleIncomes: setIncomes,
            handleExpenses: setExpenses,
            handleValidateObligatoryFields: validateObligatoryFields,
            handleLoadValidateObligatoryFields: loadValidateObligatoryFields,
            handleDirtyWhereHousingField: dirtyWhereHousingField,
            handleSetValidFirstStep: setValidFirstStep,
            handleChangeModalActive: changeModalActive,
            handleActionPreviousNextButton: actionPreviousNextButton,
            handleGetCatalogInformation: getCatalogInformation,
            handleSavePersonalData: (token, isClient) => savePersonalData(token, isClient, history),
            handleSetNeedMoneyByUser: setNeedMoneyByUser
        };

        const wizardHasError = immMortgageRequest.get('error')
        const communityList = Object.keys(codes).map(key => ({ 'name': names[key], 'id': codes[key] }));
        const finalTitle = this.getHeaderTitle();

        return (
            <div>
                <MortgageRequestPreApproval
                    immMortgageRequest={immMortgageRequest}
                    flagBasedFeatures={flagBasedFeatures}
                    immProfile={immProfile}
                    immGlobalVariables={immGlobalVariables}
                    immMortgageRequestState={immMortgageRequestState}
                    isClientWithoutAccounts={isClientWithoutAccounts}
                    setVisibleStep={setVisibleStep}
                    validateStep={(currentStep) => validateStep(currentStep, history)}
                    formHandlers={formHandlers}
                    communityList={communityList}
                    linkMortgage={linkMortgage}
                    preApprovalLoadAFI={preApprovalLoadAFI}
                    preApprovalLoadAFIFinish={preApprovalLoadAFIFinish}
                    preApprovalUUID={preApprovalUUID}
                    getInsurancesDataAfi={getInsurancesDataAfi}
                    mortgageHomeInsurance={mortgageHomeInsurance}
                    productTypeInf={productTypeInf}
                    handleKoReturnWizard={handleKoReturnWizard}
                    toggleCounterOfferView={toggleCounterOfferView}
                    acceptPreApprovalCounterOffer={acceptPreApprovalCounterOffer}
                    resetState={resetState}
                    preApprovalRequest={preApprovalRequest}
                    taxesInformationRequest={taxesInformationRequest}
                    immTaxesInformation={immTaxesInformation}
                    savePartialProcess={savePartialProcess}
                    restoreProcess={restoreProcess}
                    immMortgageRequestSimulationLinkClient={immMortgageRequestSimulationLinkClient}
                    discardTemporalChangesInCurrentModal={discardTemporalChangesInCurrentModal}
                    clearTemporalChangesInCurrentModal={clearTemporalChangesInCurrentModal}
                    immCollectives={immCollectives}
                    setMaxHousingCost={setMaxHousingCost}
                    requestConditions={requestConditions}
                    mortgageConditions={mortgageConditions}
                    finalTitle={finalTitle}
                    immScreen={immScreen}
                />
                {!wizardHasError && this.buildPreApprovalFooter()}
                {!wizardHasError && this.buildFooter()}

             </div>
        );
    }

    shouldShowTitleWithVariables() {
        const { immMortgageRequest } = this.props;
        const wizardCurrentStep = immMortgageRequest.get('visibleStep');
        const showCounterOfferView = immMortgageRequest.get('showCounterOfferView');

        return (
            wizardCurrentStep === WIZARD_THIRD_STEP ||
            wizardCurrentStep === WIZARD_FOURTH_STEP ||
            showCounterOfferView
        );
    }

    getHeaderTitle() {
        const { immMortgageRequest } = this.props;
        const titleKey = this.shouldShowTitleWithVariables()
            ? 'mortgageRequestPreApprovalCounterOffer-mortgageRequestPreApprovalCounterOffer_title'
            : 'mortgageRequestPreApproval-title';
        const originalTerm = immMortgageRequest.get('timeMoneyReturn');
        const amount = immMortgageRequest.get('moneyNeed');
        const formattedAmount = MortgageRequestCurrencyHelp({ currency: amount, symbol: EURO_TEXT, withDecimals: false });
        const productType = MortgageRequestPreApprovalView.productTypes[immMortgageRequest.get('productType')];
        const titleStrings = [productType, formattedAmount, originalTerm];
        const finalTitle = getFinalTitle(titleKey, titleStrings);

        return finalTitle;
    }

    render() {
        const { immScreen } = this.props;
        const breadcrumb = this.buildBreadcrum();
        const content = this.buildContent();
        const disclaimer = this.buildDisclaimer();
        const finalTitle = this.getHeaderTitle();

        return (
            <div>
                <div className="container-fluid">
                    {!immScreen.get('isMobile') &&
                        <div className="row">
                            <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={breadcrumb}
                                    finalTitle={finalTitle}
                                />
                            </OKCover>
                        </div>
                    }
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                            {disclaimer}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestPreApprovalView.propTypes = {
    acceptPreApprovalCounterOffer: PropTypes.func.isRequired,
    actionPreviousNextButton: PropTypes.func.isRequired,
    changeModalActive: PropTypes.func.isRequired,
    clearTemporalChangesInCurrentModal: PropTypes.func.isRequired,
    dirtyWhereHousingField: PropTypes.func.isRequired,
    discardTemporalChangesInCurrentModal: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    getCatalogInformation: PropTypes.func.isRequired,
    getCollectiveInfo: PropTypes.func.isRequired,
    getInsurancesDataAfi: PropTypes.func.isRequired,
    handleKoReturnWizard: PropTypes.func.isRequired,
    immCollectives: PropTypes.object,
    immGlobalVariables: PropTypes.object,
    immMortgageRequest: PropTypes.object.isRequired,
    immMortgageRequestSimulationLinkClient: PropTypes.object,
    immMortgageRequestState: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    immTaxesInformation: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    linkMortgage: PropTypes.func.isRequired,
    loadValidateObligatoryFields: PropTypes.func.isRequired,
    mortgageHomeInsurance: PropTypes.func.isRequired,
    preApprovalLoadAFI: PropTypes.func.isRequired,
    preApprovalLoadAFIFinish: PropTypes.func.isRequired,
    preApprovalRequest: PropTypes.func.isRequired,
    preApprovalUUID: PropTypes.func.isRequired,
    productTypeInf: PropTypes.func.isRequired,
    resetState: PropTypes.func.isRequired,
    restoreProcess: PropTypes.func.isRequired,
    savePartialProcess: PropTypes.func.isRequired,
    savePersonalData: PropTypes.func,
    setExpenses: PropTypes.func.isRequired,
    setDayOfBirth: PropTypes.func.isRequired,
    setDependents: PropTypes.func.isRequired,
    setHolder: PropTypes.func.isRequired,
    setIncomes: PropTypes.func.isRequired,
    setInfoOtherLoansMortgages: PropTypes.func.isRequired,
    setInfoStepOne: PropTypes.func.isRequired,
    setMaritalStatus: PropTypes.func.isRequired,
    setMaxHousingCost: PropTypes.func.isRequired,
    setMoneyNeedPercentageValue: PropTypes.func.isRequired,
    setMonthOfBirth: PropTypes.func.isRequired,
    setNeedMoneyByUser: PropTypes.func.isRequired,
    setOwner: PropTypes.func.isRequired,
    setStudies: PropTypes.func.isRequired,
    setValidFirstStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWork: PropTypes.func.isRequired,
    setYearOfBirth: PropTypes.func.isRequired,
    taxesInformationRequest: PropTypes.func.isRequired,
    toggleCounterOfferView: PropTypes.func.isRequired,
    validateObligatoryFields: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    requestConditions: PropTypes.func.isRequired,
    mortgageConditions: PropTypes.object,
    history: PropTypes.object.isRequired,
    setInfoFromPublicUrl: PropTypes.func.isRequired,
};

module.exports.constructor = MortgageRequestPreApprovalView;
module.exports.MortgageRequestPreApprovalView = withRouter(connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immCollectives: state.collectives,
        immGlobalVariables: state.globalVariables,
        immMortgageRequest: state.mortgageRequestPreApproval,
        immMortgageRequestSimulationLinkClient: state.mortgageRequestSimulationLinkClient,
        immMortgageRequestState: state.mortgageRequestState,
        immProfile: state.profile,
        immTaxesInformation: state.mortgageRequestTaxesInformation,
        mortgageConditions: state.mortgageRequestConditions,
        immGlobalPosition: state.globalPosition,
        immScreen: state.screen,

    }), {
    acceptPreApprovalCounterOffer: mortgageRequestActions.acceptPreApprovalCounterOffer,
    actionPreviousNextButton: mortgageRequestActions.actionPreviousNextButton,
    changeModalActive: mortgageRequestActions.changeModalActiveSavingProcess,
    clearTemporalChangesInCurrentModal: mortgageRequestActions.clearTemporalChangesInCurrentModal,
    dirtyWhereHousingField: mortgageRequestActions.dirtyWhereHousingField,
    discardTemporalChangesInCurrentModal: mortgageRequestActions.discardTemporalChangesInCurrentModal,
    getCollectiveInfo: collectivesActions.getCollectiveInfo,
    getCatalogInformation: mortgageRequestActions.getCatalogInformation,
    getInsurancesDataAfi: mortgageRequestActions.getInsurancesDataAfi,
    handleKoReturnWizard: mortgageRequestActions.koReturnWizard,
    linkMortgage: mortgageRequestActions.linkMortgage,
    loadValidateObligatoryFields: mortgageRequestActions.loadValidateObligatoryFields,
    mortgageHomeInsurance: mortgageRequestActions.mortgageHomeInsurance,
    preApprovalLoadAFI: mortgageRequestActions.preApprovalLoadAFI,
    preApprovalLoadAFIFinish: mortgageRequestActions.preApprovalLoadAFIFinish,
    preApprovalRequest: mortgageRequestActions.preApproval,
    preApprovalUUID: mortgageRequestActions.preApprovalUUID,
    productTypeInf: mortgageRequestActions.productTypeInf,
    resetState: mortgageRequestActions.resetState,
    restoreProcess: mortgageRequestActions.restoreProcess,
    savePartialProcess: mortgageRequestActions.savePartialProcess,
    savePersonalData: linkClientActions.savePersonalData,
    setDayOfBirth: mortgageRequestActions.setDayOfBirth,
    setDependents: mortgageRequestActions.setDependents,
    setExpenses: mortgageRequestActions.setExpenses,
    setHolder: mortgageRequestActions.setHolder,
    setIncomes: mortgageRequestActions.setIncomes,
    setInfoOtherLoansMortgages: mortgageRequestActions.setInfoOtherLoansMortgages,
    setInfoStepOne: mortgageRequestActions.setInfoStepOne,
    setMaritalStatus: mortgageRequestActions.setMaritalStatus,
    setMaxHousingCost: mortgageRequestActions.setMaxHousingCost,
    setMoneyNeedPercentageValue: mortgageRequestActions.setMoneyNeedPercentageValue,
    setMonthOfBirth: mortgageRequestActions.setMonthOfBirth,
    setNeedMoneyByUser: mortgageRequestActions.setNeedMoneyByUser,
    setOwner: mortgageRequestActions.setOwner,
    setStudies: mortgageRequestActions.setStudies,
    setValidFirstStep: mortgageRequestActions.setValidFirstStep,
    setVisibleStep: mortgageRequestActions.setVisibleStep,
    setWork: mortgageRequestActions.setWork,
    setYearOfBirth: mortgageRequestActions.setYearOfBirth,
    taxesInformationRequest: mortgageRequestTaxesInformationActions.taxesInformationRequest,
    toggleCounterOfferView: mortgageRequestActions.toggleCounterOfferView,
    validateObligatoryFields: mortgageRequestActions.validateObligatoryFields,
    validateStep: mortgageRequestActions.validateStep,
    requestConditions: mortgageRequestConditionsActions.requestConditions,
    setInfoFromPublicUrl: mortgageRequestActions.setInfoFromPublicUrl,
}
)(MortgageRequestPreApprovalView));
